import { Carousel } from './Carousel';

export const TxtCarousel = ({...props}) => {
    return (
        <Carousel>
            {props.children}
        </Carousel>
    );
};
